import React, { memo } from 'react';
import { Wrapper } from './chess-game.styled';
import Playground from './components/playground';
import Header from '@/components/header/header';
import Add from '@/assets/game-chess/Add.png';
import Banner from '@/assets/game-chess/Banner.png';
import Line from '@/assets/game-chess/Line.png';
import Line2 from '@/assets/game-chess/line2.png';
import Rank1 from '@/assets/game-chess/rank1.png';
import Rank2 from '@/assets/game-chess/rank2.png';
const ChessGameComponent = () => {
  return (
    <Wrapper>
      <Header />
      <div className='app-container w-full flex flex-col items-center'>
        <Playground />
        <div className='balance-button flex items-center justify-between px-6 mt-10'>
          <div className='flex items-center gap-2'>
            <img src={Add} className='w-10 cursor-pointer' alt='' />
            <span className='text-[32px] font-medium text-[#4E3203]'>123,456 $ARC</span>
          </div>
          <span className='text-[20px] font-medium text-[#4E3203]'>100 $ARC/game</span>
        </div>
        <div className='w-full max-w-[852px] flex flex-col items-center px-7 bg-[#1E1E1E] rounded-2xl mt-20 gap-4'>
          <img src={Banner} className='w-20 -mt-10' alt='' />
          <div className='font-medium text-[32px]'>Super Chess</div>
          <span className='font-light text-[14px] text-[#B3B3B3] text-center'>
            {`Chess is one of the oldest and most popular board games. It is played by two opponents on a checkered board
          with specially designed pieces of contrasting colours, commonly white and black. The objective of the game is
          to capture the opponent's king.`}
          </span>
        </div>
        <div className='w-full flex flex-col items-center mt-40'>
          <div className='font-normal text-[48px] secondary-font'>Leaderboard</div>
          <img src={Line} className='w-full mt-10' alt='' />
          <div className='w-full bg-[#1E1E1E] rounded-2xl py-8 px-7 my-6'>
            <div className='w-full flex items-center justify-between h-[72px]'>
              <div className='flex-[0.08] font-semibold text-[#B3B3B3]'>Rank</div>
              <div className='flex-[0.25] font-semibold text-[#B3B3B3]'>User</div>
              <div className='flex-[0.17] font-semibold text-[#B3B3B3]'>Date</div>
              <div className='flex-[0.25] font-semibold text-[#B3B3B3] text-end'>Bet</div>
              <div className='flex-[0.25] font-semibold text-[#B3B3B3] text-end'>Payout</div>
            </div>
            <div className='w-full flex items-center justify-between  h-[72px]'>
              <div className='flex-[0.08] font-semibold text-[#B3B3B3]'>
                <img src={Rank1} className='w-10' alt='' />
              </div>
              <div className='flex-[0.25] font-semibold text-[#B3B3B3]'>Hidden</div>
              <div className='flex-[0.17] font-semibold text-[#B3B3B3]'>Feb 24, 206</div>
              <div className='flex-[0.25] font-semibold text-[#B3B3B3] text-end'>Bet</div>
              <div className='flex-[0.25] font-semibold text-[#B3B3B3] text-end'>Payout</div>
            </div>
            <div className='w-full flex items-center justify-823,120 $ARCween  h-[72px]'>
              <div className='flex-[0.08] font-semibold text-[#B3B3B3]'>
                <img src={Rank2} className='w-10' alt='' />
              </div>
              <div className='flex-[0.25] font-semibold text-[#B3B3B3]'>Hidden</div>
              <div className='flex-[0.17] font-semibold text-[#B3B3B3]'>Feb 24, 206</div>
              <div className='flex-[0.25] font-semibold text-[#B3B3B3] text-end'>823,120 $ARC</div>
              <div className='flex-[0.25] font-semibold text-[#B3B3B3] text-end'>Payout</div>
            </div>
            <div className='w-full flex items-center justify-823,120 $ARCween  h-[72px]'>
              <div className='flex-[0.08] font-semibold text-[#B3B3B3]'>
                <img src={Rank1} className='w-10' alt='' />
              </div>
              <div className='flex-[0.25] font-semibold text-[#B3B3B3]'>Hidden</div>
              <div className='flex-[0.17] font-semibold text-[#B3B3B3]'>Feb 24, 206</div>
              <div className='flex-[0.25] font-semibold text-[#B3B3B3] text-end'>Bet</div>
              <div className='flex-[0.25] font-semibold text-[#B3B3B3] text-end'>Payout</div>
            </div>
          </div>
          <img src={Line2} className='w-full' alt='' />
        </div>

        <div className='w-full flex flex-col items-center mt-40 mb-40'>
          <div className='font-normal text-[48px] secondary-font'>Recommended</div>
        </div>
      </div>
    </Wrapper>
  );
};
export const ChessGame = memo(ChessGameComponent);
